<template>
  <div class="news-manage">
    <header>
      <span class="title">新闻管理</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="搜索标题" suffix-icon="el-icon-search" @keyup.enter.native="getNewsList()"></el-input>
        <span class="span-title">发布官网</span>
        <el-select v-model="siteValue" @change="getNewsList('siteChange')" size="small" placeholder="请选择">
          <el-option
            v-for="item in siteOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="span-title">分类</span>
        <el-select v-model="sortValue" @change="getNewsList()" size="small" placeholder="请选择">
          <el-option
            v-for="item in sortOptions"
            :key="item.id"
            :label="item.type_name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button size="small" @click="addNews()" type="primary" v-if="funAuth.includes(49)">添加新闻</el-button>
      </div>
    </header>
    <el-table
      class="el-table-01"
      :data="tableData"
      style="width: 100%">
      <el-table-column label="标题" width="471">
        <template slot-scope="scope">
          <span style="color: #EB2727;">{{scope.row.is_top === '1' ? '[顶]':''}}</span>{{scope.row.new_title}}
        </template>
      </el-table-column>
      <el-table-column
        label="发布官网"
        width="120">
        <template slot-scope="scope">
          {{scope.row.source === 1? '官网':'定制网'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="type_name"
        label="分类"
        width="150">
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="180">
        <template slot-scope="scope">
          {{scope.row.create_time | formatDate('yyyy-MM-dd HH:mm')}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operator-btn" @click="edit(scope.row.id)" v-if="funAuth.includes(50)">编辑</span>
          <span class="operator-btn" @click="recallOrPublish(scope.row.new_status,scope.row.id)" v-if="funAuth.includes(50)">{{scope.row.new_status === 1 ? '撤回':'发布'}}</span>
          <span class="operator-btn" @click="addNews(scope.row.id)" v-if="funAuth.includes(49)">复制</span>
          <span class="operator-btn" @click="del(scope.row.id)" v-if="funAuth.includes(51)">删除</span>
          <span class="operator-btn" @click="topNews(scope.row)" v-if="funAuth.includes(50)">{{scope.row.is_top === '1' ? '取消置顶':'置顶'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
      :current-page='pageNum'
      :page-sizes='[10, 20, 50, 100]'
      :page-size='pageSize'
      layout='total, sizes, prev, pager, next, jumper'
      :total='tableTotal'>
    </el-pagination>
    <div class="mask n1" v-if="dialogAdd"></div>
    <transition name="slide">
      <!-- currentId:详情id -->
      <news-add v-if="dialogAdd" :currentId="currentId" :isEdit="isEdit"></news-add>
    </transition>
  </div>
</template>
<script>
import newsAdd from './news-add.vue'
import mixin from '@/common/js/mixins.js'
export default {
  components: {
    newsAdd
  },
  mixins: [mixin],
  name: 'newsManage', // 新闻管理组件
  data () {
    return {
      moduleId: 15, // 模块ID
      dialogAdd: false,
      editorHTML: '',
      currentId: '',
      isEdit: false,
      pageNum: 1,
      pageSize: 10,
      tableTotal: 0,
      searchInput: '', // 搜索内容
      siteValue: '', // 发布官网
      sortValue: '', // 分类
      // 发布官网选项
      siteOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '官网'
        },
        {
          value: 2,
          label: '定制网'
        }
      ],
      // 分类选项
      sortOptions: [],
      tableData: []
    }
  },
  created () {
    // 获取新闻列表
    this.getNewsList()
    // 获取新闻分类
    this.getNewsSortList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  mounted () {
    // 关闭弹窗
    this.$bus.on('closeAddNews', (tag) => {
      this.dialogAdd = false
      if (tag === 'refreshList') {
        // 获取新闻列表
        this.getNewsList()
      }
      this.currentId = ''
    })
  },
  methods: {
    // addNews
    addNews (id) {
      this.currentId = id
      this.isEdit = false
      this.dialogAdd = true
    },
    // 编辑
    edit (id) {
      this.currentId = id
      this.isEdit = true
      this.dialogAdd = true
    },
    // 修改发布状态
    updataStatus (id, newStatus) {
      let obj = {
        'id': id,
        'new_status': newStatus === 1 ? 2 : 1 // 新闻状态（1，发布，2暂存/未发布)
      }
      this.$http.newsUpdateNewsStatus(obj).then(res => {
        this.$message({
          showClose: true,
          type: 'success',
          message: '操作成功!'
        })
        this.getNewsList()
      })
    },
    // 页容量
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.pageNum = 1
      this.getNewsList('page')
    },
    // 跳页
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getNewsList('page')
    },
    // 获取新闻分类 source （1官网，2定制网）为空默认获取所有
    getNewsSortList () {
      this.$http.newsQueryNewType({'source': this.siteValue}).then(res => {
        this.sortOptions = res.dataList
        // 分类选项加全部
        this.sortOptions.unshift({id: '', type_name: '全部'})
      })
    },
    // 撤回?发布?
    recallOrPublish (status, id) {
      if (status === 1) {
        // 撤回操作
        this.$confirm('是否确认撤回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 撤回接口 todo
          this.updataStatus(id, status)
        })
      } else {
        // 发布操作
        this.$confirm('是否确认发布?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 发布接口 todo
          this.updataStatus(id, status)
        })
      }
    },
    // 删除列表
    del (id) {
      this.$confirm('确定要删除该新闻吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.newsDeleteNews({'id': id}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          // 刷新列表
          this.getNewsList()
        })
      })
    },
    // 获取新闻列表
    getNewsList (str) {
      if (str === 'siteChange') {
        // 选择官网调用
        this.getNewsSortList()
        // 此时分类默认选择全部
        this.sortValue = ''
      }
      let obj = {
        'new_title': this.searchInput,
        'source': this.siteValue, // int 请求来源（1官网，2定制网）空:全部
        'type_id': this.sortValue, // int 新闻分类 空:全部
        'pageSize': this.pageSize,
        'pageNum': str === 'page' ? this.pageNum : 1 // 除分页器外，其他调用时pageNum为1
        // 'pageNum': this.pageNum
      }
      this.$http.newsQueryNewsList(obj).then(res => {
        this.tableData = res.dataList
        this.tableTotal = res.pageInfo.totalRows
        this.pageSize = res.pageInfo.pageSize
        this.pageNum = res.pageInfo.pageNum
      })
    },
    // 获取新闻分类 source （1官网，2定制网）为空默认获取所有
    topNews (data) {
      let jsondata = {'id': data.id, 'is_top': data.is_top === '1' ? 0 : 1}
      console.log(jsondata)
      this.$http.topNews(jsondata).then(res => {
        this.getNewsList()
      })
    }
  }
}
</script>
<style lang="scss">
.news-manage {
  height: 100%;
  overflow: auto;
  .span-title {
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/news/news-manage.vue